import React, { memo } from 'react';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';

import style from './style.module.css';

const EmailTemplatePreviewPopupComponent = ({ popupLoading, templatePreview, onNext, onPrev, onEdit }) => {
  const header = 'Email Template';

  const fromEmail = templatePreview?.get('fromEmail', '') ? (
    <>
      {templatePreview?.get('fromName', '')}&nbsp; &lt;
      <a href={`"${templatePreview?.get('fromEmail', '')}"`}>{templatePreview?.get('fromEmail', '')}</a>&gt;
    </>
  ) : (
    ''
  );

  const footer = (
    <div className="d-flex align-items-center">
      <div className="d-flex w100p">
        <Button onClick={onPrev} type="button">
          Prev
        </Button>
        <Button onClick={onNext} type="button">
          Next
        </Button>
      </div>
      <Button className="btn-link" disabled={popupLoading} onClick={onEdit} type="button">
        Edit the Template
      </Button>
    </div>
  );

  return (
    <Popup footer={footer} header={header} id="emailTemplatePreviewPopup" loading={popupLoading}>
      <div className="row mb15">
        <div className="col-md-12">
          <b>Subject: </b>
          {templatePreview?.get('subject', '')}
        </div>
      </div>
      <div className="row mb15">
        <div className="col-md-12">
          <b>From: </b>
          {fromEmail}
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <iframe
            className={style.preview}
            sandbox="allow-same-origin allow-scripts"
            srcDoc={templatePreview?.get('previewHtml', '')}
            title="content"
          />
        </div>
      </div>
    </Popup>
  );
};

export const EmailTemplatePreviewPopup = memo(EmailTemplatePreviewPopupComponent);
